import { Component, OnInit, ViewChild, ElementRef, OnDestroy} from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IAirport, IOperation } from './airport-interfaces';
import { AirportService } from './airport.service';
import { QueryReportService} from '../query-reports/query-report.service';
import { IQueryReportResponse, IQueryReportRequest} from '../query-reports/query-report';
import { IScenario, ScenarioService } from '../scenario-activities/scenario.service';
import { UserSession } from '../shared/user-session';
import { UserInfoService } from '../shared/user-info.service';
import { DegreesFromSecondsPipe } from './degrees-from-seconds.pipe';
import { DialogModule } from 'primeng/primeng';
import { Dialog } from 'primeng/primeng';
import { Button } from 'primeng/primeng';
import {Messages} from 'primeng/primeng';
import * as _ from 'lodash';

@Component({
    //templateUrl: 'app/airports/airport.component.html',
    template: require('./airport.component.html'),
    styles: [require('../styles/faa_styles.css'), require('../styles/print_faa_styles.css')],
    //styleUrls: ['app/products/product-list.component.css'],
    directives: [ROUTER_DIRECTIVES, Dialog, Button],
    pipes: [DegreesFromSecondsPipe]
})

export class AirportComponent implements OnInit, OnDestroy{
    pageTitle: string = 'Facility View ';
    errorMessage: string;
    airport: IAirport;
    private sub: any;    
    currentScenario: IScenario;
    allScenarios: IScenario[];
    scenarioHeaderDiv: HTMLDivElement;
    displayNotes: boolean = false;
    scenarioNote: string;
    notesTitle: string;
    facListTitle: string;
    graphDataTitle:string;

    isScenarioOwner: boolean = false;
    canEdit: boolean = false;
    nextFacility: string;
    previousFacility: string;
    operations: IOperation[];
    facList:IAirport[];
    displayFacilityList:boolean=false;
    cols: any[];
    displaySpinner:boolean=false;
    request : IQueryReportRequest ;
    facReportListResponse : IQueryReportResponse[];
    msgs: Messages[]=[];
    msgsAll: Messages[]=[];
    displayGraphData: boolean=false;
    showAll: string="true";

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _airportService: AirportService,
                private _scenarioService: ScenarioService, 
                private User: UserSession, 
                private _userInfoService: UserInfoService,
                private _queryReport:QueryReportService) {
    }

    @ViewChild('scenarioHeader') scenarioHeader: ElementRef;

    ngOnInit(): void{

        this.sub = this.route.params.subscribe(
            params => {
                let id = params['locId'];
                if(!_.isEmpty(id)){
                    this.getAirport(id);
                }
                else{
                     //console.log("Empty param");
                     this.getAirportFromScenario();
                }
            }
        );
       

        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
        this._scenarioService.getScenarios(this.User.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    this.setScenarioHeader(this.User.getSession().scenarioId);
                }
            );
        
        //this probably needs to be somewhere more central
        
        this.User.updateSessionState();
        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(
            success => this.isScenarioOwner = success.isOwner,
            error => this.errorMessage = <any>error
        );

        this.getOperations();
       // this.request = new IQueryReportRequest(0,1,6,10,['ATL']);
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    getOperations(){
         this._airportService.getOperations()
            .subscribe(
                operations => this.operations = operations,
                error => this.errorMessage = <any>error);
    }

    getAirportFromScenario(){
        //console.log("this.User.getSession().scenarioId " + this.User.getSession().scenarioId);
        this._airportService.getAirportFromScenario(this.User.getSession().scenarioId)
            .subscribe(
                success => this.getAirport(success),
                error => this.errorMessage = <any>error
            )
    }

    getAirport(locId: string) {
        this._airportService.getAirport(locId, this.User.getSession().scenarioId)
            .subscribe(
                airport => this.airport = airport,
                error =>  this.errorMessage = <any>error,
                () => {
                    if(this.airport.locId == undefined){
                        this.msgsAll=[];
                        this.msgsAll.push({severity:'error', summary:'Error Message', detail: 'If you were requesting a LOCID, it may not be part of your current scenario, or the LOCID is not found.' });
                        this.showAll="false";
                    }
                    else{
                        this.msgsAll=[];
                        this.showAll="true";
                        this.setCanEdit();
                        this.setNextAndPrevious(locId);
                    }
                });
    }

    setNextAndPrevious(locId: string){

        this._airportService.getNextAndPreviousAirports(locId, this.User.getSession().scenarioId)
            .subscribe(
                success => {
                    this.nextFacility = success.nextAirport;
                    this.previousFacility = success.previousAirport;
                }
            );
    }

    setCanEdit(){
        this._userInfoService.getRegCode(this.User.getSession()['id'])
            .subscribe(
                success => {
                    if(this.User.getSession().isAdmin || (this.User.getSession().isRegionalManager && success === this.airport.region)){
                        this.canEdit = true;
                    } 
                }
            );
    }

    onScenarioChange(event: Event):void {
        let selectedScenarioId:number = +(event.target as HTMLSelectElement).value;
        this.User.scenarioId = selectedScenarioId;
        this.User.updateSessionState();
        this.setScenarioHeader(selectedScenarioId); 

        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(
            success => this.isScenarioOwner = success.isOwner,
            error => this.errorMessage = <any>error
        );

        this.getAirportFromScenario();
    }

    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
        this.scenarioHeaderDiv.innerHTML = `<strong>Current Scenario: ${this.currentScenario.scenarioName} (${this.currentScenario.id})</strong>`;
    }

    showNotes() {

        if(this.isScenarioOwner || this.User.getSession().isAdmin){
            this.notesTitle = "Edit Scenario Notes";
        }
        else{
            this.notesTitle = "View Scenario Notes";
        }

        this._airportService.getScenarioNotes(this.airport.locId, this.User.getSession().scenarioId)
                .subscribe(
                    success => {
                        if(!_.isEmpty(success)){
                            this.scenarioNote = success;
                        }
                        this.displayNotes = true;
                    },
                    error => this.errorMessage = "An error occured while attempting to retrieve notes."
                );
    }

    showDataReport(){
      this.request =  new IQueryReportRequest(1,0,6,10,[this.airport.locId]);
      this.request.scenario = this.currentScenario.id;
      //year is fy_year -3 and will get calculated on webAPI side of the house; don't want to do that here also.
      this.request.startYear = 0;
      //these two values are hardcoded to reflect data from query reports: facility levelr eport data summary (6) for a certain facility (10)
      this.request.reportId = 6;
      this.request.facOption = 10;
      this.request.locidList=[this.airport.locId];
 
      if(this.isScenarioOwner || this.User.getSession().isAdmin || this.User.isReadOnly){
            this.graphDataTitle = "Data Report";
            this.displaySpinner = true;
            this._queryReport.getFacilityListReport(this.request)
            .subscribe(
                    response => {
                    this.displaySpinner = false;
                    this.facReportListResponse = response;
                    if (this.facReportListResponse[0].responseStatus === 'ERROR') {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', detail: 'An error has occurred executing your request'
                                        +this.facReportListResponse[0].responseMessage});
                    }
                    else if (this.facReportListResponse[0].responseMessage === 'No Data') {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Info Message', detail: 'No Data returned.'
                                        +this.facReportListResponse[0].responseMessage});
                        this.facReportListResponse[0].pdfFileUrl="";
                        this.facReportListResponse[0].htmlFileUrl="";
                    }
                    else{
                        this.msgs=[];
                        this.msgs.push({severity:'info', summary:'Info Message', detail: 'PDF & HTML file generated; please click links below' });
                        this.cols = [
                                    {field: "htmlFileUrl", header: 'Html'},
                                    {field: "pdfFileUrl", header: 'Pdf'},

                        ]
                        this.displayGraphData =true;
                    }
                    //console.log ("Airport Data report response facility report " + this.facReportListResponse[0].htmlFileUrl + "  " 
                    //                + this.facReportListResponse[0].pdfFileUrl +" " + this.facReportListResponse[0].responseMessage +" "
                    //                + this.facReportListResponse[0].responseStatus +" " + this.facReportListResponse[0].responseDisplay)
                },
                error => this.errorMessage = <any>error
                );
      }
    }
    showGrowthRateReport(){
      this.facListTitle = "Growth Rate Report";
      this.request =  new IQueryReportRequest(1,0,7,10,[this.airport.locId]);
      this.request.scenario = this.currentScenario.id;
      //year is fy_year -3 and will get calculated on webAPI side of the house; don't want to do that here also.
      this.request.startYear = 0;
      //these two values are hardcoded to reflect data from query reports: facility levelr eport data summary (6) for a certain facility (10)
      this.request.reportId = 7;
      this.request.facOption = 10;
      this.request.locidList=[this.airport.locId];
 
      if(this.isScenarioOwner || this.User.getSession().isAdmin || this.User.isReadOnly){
            this.graphDataTitle = "Growth Rate Report";
            this.displaySpinner = true;
            this._queryReport.getFacilityListReport(this.request)
            .subscribe(
                    response => {
                    this.displaySpinner = false;
                    this.facReportListResponse = response;
                    if (this.facReportListResponse[0].responseStatus === 'ERROR') {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', detail: 'An error has occurred executing your request'
                                        +this.facReportListResponse[0].responseMessage});
                    }
                    else if (this.facReportListResponse[0].responseMessage === 'No Data') {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Info Message', detail: 'No Data returned.'
                                        +this.facReportListResponse[0].responseMessage});
                        this.facReportListResponse[0].pdfFileUrl="";
                        this.facReportListResponse[0].htmlFileUrl="";
                    }
                    else{
                        this.msgs=[];
                        this.msgs.push({severity:'info', summary:'Info Message', detail: 'PDF & HTML file generated; please click links below' });
                        this.cols = [
                                    {field: "htmlFileUrl", header: 'Html'},
                                    {field: "pdfFileUrl", header: 'Pdf'},

                        ]
                        this.displayGraphData =true;
                    }
                    //console.log ("Airport Data report response facility report " + this.facReportListResponse[0].htmlFileUrl + "  " 
                    //                + this.facReportListResponse[0].pdfFileUrl +" " + this.facReportListResponse[0].responseMessage +" "
                    //                + this.facReportListResponse[0].responseStatus +" " + this.facReportListResponse[0].responseDisplay)
                },
                error => this.errorMessage = <any>error
                );
      }
    }
    showOpsPerBA(){
      this.facListTitle = "Operations Per Based Aircraft Ratio";
      this.request =  new IQueryReportRequest(1,0,7,10,[this.airport.locId]);
      this.request.scenario = this.currentScenario.id;
      //year is fy_year -3 and will get calculated on webAPI side of the house; don't want to do that here also.
      this.request.startYear = 0;
      //these two values are hardcoded to reflect data from query reports: facility levelr eport data summary (6) for a certain facility (10)
      this.request.reportId = 12;
      this.request.facOption = 0;
      this.request.locidList=[this.airport.locId];
 
      if(this.isScenarioOwner || this.User.getSession().isAdmin || this.User.isReadOnly){
            this.graphDataTitle = "Operations Per Based Aircraft Ratio";
            this.displaySpinner = true;
            this._queryReport.getFacilityListReport(this.request)
            .subscribe(
                    response => {
                    this.displaySpinner = false;
                    this.facReportListResponse = response;
                    if (this.facReportListResponse[0].responseStatus === 'ERROR') {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', detail: 'An error has occurred executing your request'
                                        +this.facReportListResponse[0].responseMessage});
                    }
                    else if (this.facReportListResponse[0].responseMessage === 'No Data') {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Info Message', detail: 'No Data returned.'
                                        +this.facReportListResponse[0].responseMessage});
                        this.facReportListResponse[0].pdfFileUrl="";
                        this.facReportListResponse[0].htmlFileUrl="";
                    }
                    else{
                        this.msgs=[];
                        this.msgs.push({severity:'info', summary:'Info Message', detail: 'PDF & HTML file generated; please click links below' });
                        this.cols = [
                                    {field: "htmlFileUrl", header: 'Html'},
                                    {field: "pdfFileUrl", header: 'Pdf'},

                        ]
                        this.displayGraphData =true;
                    }
                    //console.log ("Operations Per Based Aircraft Ratio response " + this.facReportListResponse[0].htmlFileUrl + "  " 
                    //                + this.facReportListResponse[0].pdfFileUrl +" " + this.facReportListResponse[0].responseMessage +" "
                    //                + this.facReportListResponse[0].responseStatus +" " + this.facReportListResponse[0].responseDisplay)
                },
                error => this.errorMessage = <any>error
                );
      }  
    }
    showFacList(){
      this.facListTitle = "Facility List";
      this.request =  new IQueryReportRequest(1,0,5,10,[this.airport.locId]);
      this.request.scenario = this.User.getSession().scenarioId;
      //year is fy_year -3 and will get calculated on webAPI side of the house; don't want to do that here also.
      this.request.startYear = 0;
      //these two values are hardcoded to reflect data from query reports: facility levelr eport data summary (6) for a certain facility (10)
      this.request.reportId = 11;
      this.request.facOption = 0;
      this.request.locidList=[this.airport.locId];
 
      if(this.isScenarioOwner || this.User.getSession().isAdmin || this.User.isReadOnly){
      
            this.graphDataTitle = "Facility List"; 
            this.displaySpinner = true;
            this._queryReport.getFacilityListReport(this.request)
            .subscribe(
                    response => {
                    this.displaySpinner = false;
                    this.facReportListResponse = response;
                    if (this.facReportListResponse[0].responseStatus === 'ERROR') {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', detail: 'An error has occurred executing your request'
                                        +this.facReportListResponse[0].responseMessage});
                    }
                    else if (this.facReportListResponse[0].responseMessage === 'No Data') {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Info Message', detail: 'No Data returned.'
                                        +this.facReportListResponse[0].responseMessage});
                        this.facReportListResponse[0].pdfFileUrl="";
                        this.facReportListResponse[0].htmlFileUrl="";
                    }
                    else{
                        this.msgs=[];
                        this.msgs.push({severity:'info', summary:'Info Message', detail: 'PDF & HTML file generated; please click links below' });
                        this.cols = [
                                    {field: "htmlFileUrl", header: 'Html'},
                                    {field: "pdfFileUrl", header: 'Pdf'},

                        ]
                        this.displayGraphData =true;
                    }
                    //console.log ("Airport Data report response facility report " + this.facReportListResponse[0].htmlFileUrl + "  " 
                    //                + this.facReportListResponse[0].pdfFileUrl +" " + this.facReportListResponse[0].responseMessage +" "
                    //                + this.facReportListResponse[0].responseStatus +" " + this.facReportListResponse[0].responseDisplay)
                },
                error => this.errorMessage = <any>error
                );
       }
       /* if(this.isScenarioOwner || this.User.getSession().isAdmin){
            this.facListTitle = "Facility List";
            this.displaySpinner = true;
            this._airportService.getFacilityList(this.User.getSession().scenarioId)
            .subscribe(
                    response => {
                        this.facList = response;
                        this.displayFacilityList = true;
                        this.cols = [
                            {field: "locId", header: 'Locid'},
                            {field: "name", header: 'Airport Name'},
                            {field: "region", header: 'Region'},
                            {field: "city", header: 'City'},
                            {field: "stateName", header: 'State'},
                            {field: "facClassName", header: 'Facility Class'},
                            {field: "facLevelName", header: 'Facility Level'},
                            {field: "latitude", header: 'Latitude'},
                            {field: "longitude", header: 'Longitude'},
                            {field: "siteNumber", header: 'Site'},
                        ]
                        console.log('Airport Get Facility List Component: ' +  JSON.stringify(this.cols));
                        this.displaySpinner =false;
                    },
                    error => this.errorMessage = "An error occured while attempting to retrieve notes."
                );
        }*/
    }
    saveNotes() { 
        this._airportService.updateScenarioNotes(this.airport.locId, this.User.getSession().scenarioId, this.scenarioNote)
                .subscribe(
                    success => {},
                    error => {
                        this.errorMessage = "An error occured while attempting to save your note.";
                        this.displayNotes = false;
                    },
                    () => this.displayNotes = false
                );
    }

    editAirport(){
        this.router.navigate([`/airports-edit/${this.airport.locId}`]);
    }

    nextFacilityAction(){
        this.router.navigate([`/airports/${this.nextFacility}`]);
    }

    
    previousFacilityAction(){
        this.router.navigate([`/airports/${this.previousFacility}`]);
    }

    performOp(op: IOperation){
        
        let params = {
            locId: this.airport.locId,
            airportName: this.airport.name
        }

        this.router.navigate([`/operations-list/${op.tableName}`, params]);
    }
    openPDFFile(responsepdf:any){
        window.open(responsepdf, '_blank');
    }
    openHTMLFile(responseHtml:any){
        window.open(responseHtml, '_blank');
    }
}



/** WEBPACK FOOTER **
 ** ./app/airports/airport.component.ts
 **/